import { ServiceIdentifier } from '../service-locator';
import { PreferencesService } from './interfaces';

export * from './interfaces';

export const PREFERENCES_SERVICE = ServiceIdentifier.get<PreferencesService>('PreferencesService');
